import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtils} from '../shared/http.utils';
import {DefaultAssetRepresentationFilters} from "../model/filters/default-asset-representation-filters";
import {DefaultAssetRepresentationPersistRequest} from "../model/requests/default-asset-representation-persist-request";

@Injectable({
  providedIn: 'root'
})
export class DefaultAssetRepresentationsService {

  private readonly representationsURL: string;

  constructor(private http: HttpClient) {
    this.representationsURL = '/catalog/default_asset_representations';
  }

  public getDefaultAssetRepresentations(offset?: number, limit?: number, filters?: DefaultAssetRepresentationFilters): Observable<any> {
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    const body = (filters != null) ? filters : new DefaultAssetRepresentationFilters();
    return this.http.post<any>(this.representationsURL, body, options);
  }

  public getDefaultAssetRepresentation(name): Observable<any> {
    const url = `${this.representationsURL}/${name}`;
    return this.http.get<any>(url);
  }

  public createDefaultAssetRepresentation(defaultAssetRepresentationCreationData: DefaultAssetRepresentationPersistRequest): Observable<any> {
    const url = `${this.representationsURL}/create`;
    return this.http.post<any>(url, defaultAssetRepresentationCreationData);
  }

  public editDefaultAssetRepresentation(defaultAssetRepresentationEditionData: DefaultAssetRepresentationPersistRequest): Observable<any> {
    const url = `${this.representationsURL}/edit`;
    return this.http.post<any>(url, defaultAssetRepresentationEditionData);
  }

  public deleteDefaultAssetRepresentation(name: string): Observable<HttpResponse<any>> {
    const url = `${this.representationsURL}/${name}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  public deleteDefaultAssetRepresentations(names: string[]): Observable<HttpResponse<any>> {
    const url = `${this.representationsURL}/delete`;
    return this.http.post<any>(url, names, {observe: 'response'});
  }

}
